import React from "react";

interface IAuthContext {
  authenticated: boolean;
  isAdmin: boolean;
  companyCode: string | null;
  companyId: number | null;
  companyName: string | null;
  userId: number | null;
  userName: string | null;
  userEmail: string | null;
  isICT: number | null;
  accessToken: string | null;
  refreshToken: string | null;
  loginLogId: number | null;
  tokenIsValid: boolean;
  loginName: string | null;
}

const authContext = React.createContext<IAuthContext>({
  authenticated: false,
  isAdmin: false,
  companyCode: null,
  companyId: null,
  companyName: null,
  userId: null,
  userName: null,
  userEmail: null,
  isICT: 0,
  accessToken: null,
  refreshToken: null,
  loginLogId: null,
  tokenIsValid: false,
  loginName: null,
});

export default authContext;
